import type { MenuModel } from '~/types/app'

export const useMenuLinks = () => {
  const defaultMenuLink: Partial<Record<string, MenuModel[]>> = {}
  const menuLinks = useState('ysc:menu-links', () => (defaultMenuLink))
  return { menuLinks }
}
